import { Card } from '@apigrowfinance/pbolt-card';

import LoadingErrorMessage from '@components/LoadingErrorMessage/LoadingErrorMessage';
import { useAccount } from '@contexts/AccountProvider';
import Account from '@pages/accountDetail/tabs/account/Account';

const AccountContainer = () => {
    const {
        isLoading,
        account,
        error: { accountIsError },
    } = useAccount();

    if (accountIsError) {
        return (
            <Card>
                <LoadingErrorMessage />
            </Card>
        );
    }

    return <Account accountDetails={account} isLoading={isLoading} />;
};

export default AccountContainer;
